<div container>
  <div class="quiz__container quiz__container--intro text-dark" #introContainer>
    <div class="quiz__tab d-flex align-items-center">
      <div class="quiz__tab-title h3 mb-0">Type 1 Risk Quiz</div>
      <div class="quiz__tab-separator"></div>
      <div class="quiz__tab-text">
        <div>This quiz is intended for people age 18 years and older and is not a diagnostic tool. </div>
        <div>Talk to your doctor for more information about T1D risk.</div>
      </div>
    </div>
    <div class="quiz__content-container d-flex flex-column flex-lg-row bg-white">
      <div class="left-side">
        <h2>Could you or a loved one be&nbsp;at risk for T1D?</h2>
        <p class="mb-4">
          An individual's risk of developing autoimmune type 1 diabetes can vary according to different factors like
          family history, or the presence of other chronic illnesses. Take this quiz to learn more about your or your
          loved one's risk for T1D and possible next steps.
        </p>
        <div class="quiz__button" global-button [buttonData]="{
            buttonLabel: 'Get started',
            buttonUrl: '#',
            openInNewTab: false,
            buttonIcon: 'right-icon',
            eventEmit: true
          }" (onButtonClick)="animateContainers()"></div>
      </div>
      <div class="right-side position-relative">
        <picture [data]=" {
          image: 'whatsyourtd1risk/section-2-image',
          webp: true,
          altext: 'A mother reading a book to her daughter',
          format: '',
          width: '626',
          height: '427',
          mobile: false,
          classes: 'img-fluid',
        }"></picture>
        <div class="position-absolute bottom-0 end-0 p-4" style="font-size: 14px; color: white; z-index: 10;">
          Actor portrayal
        </div>
      </div>
    </div>
  </div>
  <div
    class="quiz__container quiz__container--questions position-relative bg-white d-flex flex-column justify-content-between d-none"
    #questionsContainer>
    <div class="questions--top">
      <ul class="questions__pagination d-flex justify-content-between justify-content-lg-start gap-3 list-unstyled">
        <li [class.current]="questionIndex == 0">1</li>
        <li [class.current]="questionIndex == 1">2</li>
        <li [class.current]="questionIndex == 2">3</li>
        <li [class.current]="questionIndex == 3">4</li>
        <li [class.current]="questionIndex == 4">5</li>
      </ul>
      <h3 class="questions__title mb-4" [innerHTML]="getCurrentQuestionText()"></h3>
      <div class="questions__responses d-flex flex-column flex-lg-row gap-3 mb-4">
        @for (response of getCurrentResponses(); let responseIndex = $index;
        track responseIndex) {

        <button [ngClass]="{
            'custom-btn':
              questionIndex === 2 || questionIndex === 3 || questionIndex === 4
          }" class="btn btn-outline-secondary fw-bold w-100"
          [class.btn-secondary]="userResponses[questionIndex] == responseIndex" (click)="selectOption(responseIndex)"
          [innerHTML]="response.text"></button>
        }
      </div>
      <p class="questions__footnote mb-0" [innerHTML]="getCurrentQuestionFootnote()"></p>
    </div>
    <div
      class="questions__footer questions--bottom d-flex flex-wrap justify-content-center justify-content-lg-start gap-2">
      <button class="btn btn--outline-primary d-flex align-items-center gap-2 text-primary fw-bold"
        (click)="prevQuestion()">
        <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.291758 8.79922L8.35855 0.75579C8.7476 0.367862 9.37835 0.367862 9.76736 0.75579L10.7082 1.69393C11.0966 2.08119 11.0974 2.70884 10.7099 3.09702L4.31681 9.50162L10.7099 15.9062C11.0974 16.2943 11.0966 16.922 10.7082 17.3093L9.76736 18.2474C9.37831 18.6353 8.74756 18.6353 8.35855 18.2474L0.291758 10.204C-0.0972538 9.81608 -0.0972538 9.18715 0.291758 8.79922Z"
            fill="#9657D6" />
        </svg>
        <span>Back</span>
      </button>
      <button class="btn btn-primary d-flex align-items-center gap-2 text-white fw-bold" (click)="nextQuestion()"
        [disabled]="userResponses[questionIndex] == null">
        <span [innerHTML]="questionIndex == 4 ? 'See results' : 'Next'"></span>
        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.7213 8.20711C19.1119 7.81658 19.1119 7.18342 18.7213 6.79289L12.3574 0.428932C11.9668 0.0384078 11.3337 0.0384078 10.9432 0.428932C10.5526 0.819457 10.5526 1.45262 10.9432 1.84315L16.6 7.5L10.9432 13.1569C10.5526 13.5474 10.5526 14.1805 10.9432 14.5711C11.3337 14.9616 11.9668 14.9616 12.3574 14.5711L18.7213 8.20711ZM0.50708 8.5H18.0142V6.5H0.50708V8.5Z"
            fill="white" />
        </svg>
      </button>
    </div>
    <div class="questions__img d-none d-lg-block position-absolute bottom-0" [style.right]="questionImg.imageRight">
      @for (item of [questionImg]; track item.image) {
      <picture [data]="item"></picture>
      }
      <div class="position-absolute bottom-0 p-3" [ngClass]="actorPortrayalPosition === 'left' ? 'start-0' : 'end-0'"
        [style.marginLeft]="questionImg.actorMarginLeft" [style.marginRight]="questionImg.actorMarginRight"
        style="font-size: 14px; color: black; z-index: 10;">
        Actor portrayal
      </div>
    </div>
  </div>
  <div
    class="quiz__container quiz__container--results position-relative bg-white d-flex flex-column justify-content-between d-none"
    #resultsContainer>
    <div class="results__exclamation position-absolute d-none d-lg-block">
      <img class="img-fluid" [src]="'/assets/img/callout/exclamation.svg'" alt="Exclamation points" width="108"
        height="108" />
    </div>
    <div class="results__text">
      <h2 class="mb-4"> {{ quizResult?.title }} </h2>
      <h3 class="mb-3">
        {{ quizResult?.subtitle }}
      </h3>
      <p class="mb-3">
        {{ quizResult?.text }}
      </p>
    </div>
    <p>{{ quizResult?.footnote }}</p>
    <div class="results__cta">
      <p class="fw-bold mb-4 mb-lg-3">
        {{ quizResult?.silymiStatement }}
      </p>
      <div class="results__cta__box d-flex flex-column flex-lg-row mb-4">
        <div class="results__cta__btn w-fit me-lg-3 mb-3 mb-lg-0" global-button [buttonData]="{
            buttonLabel: 'See how and why to get screened',
            buttonUrl: appPaths.HOWTOSCREEN,
            openInNewTab: false,
            buttonIcon: 'right-icon',
          }"></div>
        <div class="results__cta__btn w-fit" global-button [buttonData]="{
            buttonLabel: 'Sign up for helpful information',
            buttonUrl: appPaths.SIGNUP,
            openInNewTab: false,
            buttonIcon: 'right-icon',
          }"></div>
      </div>
    </div>
    <div class="results__bottom d-flex flex-column flex-lg-row-reverse align-items-lg-end">
      <div class="results__restart-btn cursor-pointer d-flex align-items-center gap-3 w-fit mx-auto mb-3 mb-lg-0"
        (click)="resetQuiz()">
        <svg width="47" height="49" viewBox="0 0 47 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M24.2076 49C32.7529 49 40.7177 44.3067 44.9999 36.75C45.5524 35.7751 45.2249 34.5247 44.2699 33.9606C43.3124 33.3941 42.09 33.7284 41.5374 34.7058C37.97 41.0043 31.3301 44.9141 24.2075 44.9141C13.1803 44.9141 4.20752 35.7544 4.20752 24.4975C4.20752 13.2426 13.1803 4.08352 24.2075 4.08352C30.5225 4.08352 36.4526 7.16385 40.2024 12.2502H33.2072C32.1022 12.2502 31.2072 13.1638 31.2072 14.2918C31.2072 15.4199 32.1022 16.3335 33.2072 16.3335H44.2075C45.3125 16.3335 46.2075 15.4199 46.2075 14.2918V3.06236C46.2075 1.93432 45.3125 1.0207 44.2075 1.0207C43.1025 1.0207 42.2075 1.93432 42.2075 3.06236V8.29666C37.695 3.093 31.1426 0 24.2075 0C10.9723 0 0.20752 10.9916 0.20752 24.4999C0.20752 38.0082 10.9724 49 24.2076 49Z"
            fill="#9657D6" />
        </svg>
        <span class="text-primary fw-bold">RESTART</span>
      </div>
      <p class="mb-0">
        This information is based on the answers that you provided and our
        current understanding of the risk of developing type 1. The actual risk
        may be higher or lower based on a number of different factors.
      </p>
    </div>
  </div>
</div>